import React from 'react'
import PropTypes from 'prop-types'

import { StyledTile } from './styled'

const ColorTile = ({ color, setExampleColor, selectColor, togglePicker, isExample = false }) => {
	const handleClick = e => {
		e.stopPropagation()
		selectColor(color)
		togglePicker()

		isExample && setExampleColor(color)
	}

	const props = {
		isCancel: !color,
		isBordered: (color === '#ffffff'),
		isExample,
		backgroundColor: color,
		onClick: handleClick
	}

	return <StyledTile {...props} />
}

ColorTile.propTypes = {
	color: PropTypes.string,
	isExample: PropTypes.bool,
	setExampleColor: PropTypes.func,
	selectColor: PropTypes.func,
	togglePicker: PropTypes.func
}

export default ColorTile
